import React from "react";
import { Phone, Instagram, Film } from "lucide-react";
import { CONTACT, LOGO } from "../../data/content";
import { Reveal, Kicker } from "./primitives";

export const Footer = () => (
  <footer id="contact" className="relative pt-14 md:pt-40 pb-10 px-4 md:px-10" data-testid="contact">
    <div className="mx-auto max-w-[1600px]">
      <Kicker index="09">Contact</Kicker>

      <Reveal>
        <h2 className="display-h1 mt-4 md:mt-6 mb-4">Let&apos;s Design<br />The Action.</h2>
      </Reveal>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10 mt-10 md:mt-16 border-t border-border pt-8 md:pt-14">
        {/* Phone */}
        <div className="lg:col-span-6">
          <span className="kicker">Bookings & Enquiries</span>
          <a
            href={CONTACT.phoneHref}
            className="group flex items-center gap-3 sm:gap-4 mt-3 sm:mt-4 active:scale-98 transition-transform"
            data-testid="contact-phone"
          >
            <Phone size={24} className="text-[hsl(var(--accent))] md:w-7 md:h-7 shrink-0" />
            <div>
              <div className="font-display uppercase text-xl sm:text-3xl md:text-5xl leading-none group-hover:text-[hsl(var(--accent))] transition-colors">
                {CONTACT.phone}
              </div>
              <div className="kicker mt-1.5 md:mt-2 text-[10px] md:text-xs">{CONTACT.name}</div>
            </div>
          </a>
        </div>

        {/* Social + IMDb */}
        <div className="lg:col-span-6 flex flex-col gap-6">
          <div>
            <span className="kicker">Instagram</span>
            <div className="flex flex-col gap-2.5 sm:gap-3 mt-3 sm:mt-4">
              {CONTACT.instagram.map((ig) => (
                <a
                  key={ig.handle}
                  href={ig.url}
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center gap-3 font-display uppercase text-lg sm:text-xl md:text-2xl hover:text-[hsl(var(--accent))] transition-colors"
                  data-testid={`ig-${ig.handle}`}
                >
                  <Instagram size={18} className="md:w-5 md:h-5" /> {ig.handle}
                </a>
              ))}
            </div>
          </div>
          <a
            href={CONTACT.imdb}
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-3 font-mono-c text-xs tracking-[0.2em] uppercase link-underline w-fit"
            data-testid="footer-imdb"
          >
            <Film size={16} /> IMDb Profile ↗
          </a>
        </div>
      </div>

      {/* Brand seal */}
      <div className="relative mt-16 md:mt-24 flex justify-center">
        <div
          className="absolute inset-0 flex items-center justify-center pointer-events-none"
          aria-hidden="true"
        >
          <div className="h-[200px] w-[200px] sm:h-[280px] sm:w-[280px] md:h-[420px] md:w-[420px] rounded-full bg-[radial-gradient(circle,rgba(255,255,255,0.10)_0%,rgba(255,59,48,0.06)_40%,transparent_70%)] blur-xl" />
        </div>
        <img
          src={LOGO}
          alt="CF Action Design — Chethan D'Souza"
          className="relative w-44 sm:w-56 md:w-80 h-auto object-contain drop-shadow-[0_0_30px_rgba(0,0,0,0.6)]"
          data-testid="footer-logo"
        />
      </div>

      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 sm:gap-4 mt-12 md:mt-16 pt-6 md:pt-8 border-t border-border">
        <span className="font-bungee text-sm sm:text-base md:text-lg uppercase" style={{ fontFamily: "'Bungee', sans-serif" }}>
          © 2026 CF<span className="text-[hsl(var(--accent))]">.</span> Action Design
        </span>
        <span className="kicker text-[10px] md:text-xs">Bengaluru · India · International</span>
      </div>
    </div>
  </footer>
);
